import styles from "./masterclass.module.css";
import ServicoDetalheCover from "../../../components/ServicosComponents/ServicoDetalheCover/servico-detalhe-cover";
import { NavLink } from "react-router-dom";

const Masterclass = () => {
  return (
    <main className={styles.servico_detalhe_main}>
      <ServicoDetalheCover
        title="Masterclass"
        alt="Cover da página Masterclass."
      />
      <section className={styles.descricao_section}>
        <div className={styles.text}>
          <p className={styles.text_paragraph}>
            Ofertamos masterclasses em temas relacionados à epidemiologia,
            desenhos de estudos, dados de mundo real (RWD) e evidência de mundo
            real (RWE).
          </p>
        </div>
        <div className={styles.text}>
          <p className={styles.text_paragraph}>
            <b>Formato:</b>
          </p>
          <ul className={styles.servico_lista}>
            <li className={styles.lista_item}>Cursos Presenciais ou EAD</li>
            <li className={styles.lista_item}>In Company ou Aberto</li>
          </ul>
        </div>
        <div className={styles.text}>
          <p className={styles.text_paragraph}>
            <b>Temas:</b>
          </p>
          <ul className={styles.servico_lista}>
            <li className={styles.lista_item}>
              • RWD/RWE: conceitos e definições
            </li>
            <li className={styles.lista_item}>
              • Diretrizes nacionais em RWD/RWE (Guide ANVISA)
            </li>
            <li className={styles.lista_item}>
              • Diretrizes internacionais em RWD/RWE
            </li>
            <li className={styles.lista_item}>• Tendências em RWD/RWE</li>
            <li className={styles.lista_item}>
              • Desenhos de estudos em RWD/RWE
            </li>
            <li className={styles.lista_item}>• Uso de RWD/RWE em HTA</li>
            <li className={styles.lista_item}>
              • Importância da divulgação científica em RWD/RWE
            </li>
            <li className={styles.lista_item}>
              • Priorização de estudos/projetos na estratégia de posicionamento
              de produtos em saúde
            </li>
            <li className={styles.lista_item}>
              • Como elaborar uma ideia de pesquisa relevante [Gap assessment]?
            </li>
            <li className={styles.lista_item}>
              • Como testar a consistência interna das ideias de pesquisa?
            </li>
            <li className={styles.lista_item}>
              • Como testar a consistência interna de projetos de pesquisa em
              andamento?
            </li>
            <li className={styles.lista_item}>
              • Como elaborar/revisar um formulário para coleta de dados de
              forma consistente com seus protocolos de pesquisa?
            </li>
            <li className={styles.lista_item}>
              • Como otimizar a divulgação científica dos resultados de novos
              produtos?
            </li>
          </ul>
        </div>
        <div className={styles.btns_div}>
          <NavLink to="/produtos/scientific-writing-communication">
            <button className={styles.btn_produto}>
              {" Ver Scientific Writing & Communication"}
            </button>
          </NavLink>
          <NavLink to="/produtos/strategic-planning">
            <button className={styles.btn_produto}>
              {"Ver Strategic Planning"}
            </button>
          </NavLink>
        </div>
        <div className={styles.btns_divMobile}>
          <NavLink to="/produtos/scientific-writing-communication">
            <button className={styles.btn_produto}>
              {"<"}
            </button>
          </NavLink>
          <NavLink to="/produtos/strategic-planning">
            <button className={styles.btn_produto}>
              {">"}
            </button>
          </NavLink>
        </div>
      </section>
    </main>
  );
};

export default Masterclass;
